import React, { StrictMode } from 'react';
import PropTypes from 'prop-types';
import { compose, lifecycle, setDisplayName, setPropTypes } from 'recompose';
import { ConnectedRouter as Router } from 'react-router-redux';
import { Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import Meta from '../common/Meta';
import MatrixPage from '../MatrixPage';
import PaymentPage from '../PaymentPage';
import AccountPage from '../AccountPage';
import BookmakersPage from '../BookmakersPage';
import EmailConfirmationPage from '../EmailConfirmationPage';
import CustomCampaignUrl from '../CustomCampaignUrl';
import
PaymentConfirmation,
{ withRedirect } from '../PaymentPage/PaymentWizard/PaymentConfirmation';
import history from '../../history';

const handleHeaderAndFooterViews = (isShortMode) => {
  const body = document.body;

  if (isShortMode) {
    body.classList.add('ui-wrapper--grey-bgr');
    body.classList.add('ui-wrapper--short');
  } else {
    body.classList.remove('ui-wrapper--grey-bgr');
    body.classList.remove('ui-wrapper--short');
  }
};

history.listen((location) => {
  handleHeaderAndFooterViews(location.pathname.includes('payment') || location.pathname.includes('subscriptions/confirm'));
});

const Root = ({ store }) => (
  <Provider store={store}>
    <Router history={history}>
      <section>
        <StrictMode>
          <Meta />
          <Route
            exact
            path="/subscriptions"
            component={MatrixPage}
                    />
          <Route
            exact
            path="/subscriptions/payment"
            component={PaymentPage}
                    />
          <Route
            exact
            path="/subscriptions/my-account"
            component={AccountPage}
              />
          <Route
            exact
            path="/my-bookmakers"
            component={BookmakersPage}
                    />
          <Route
            exact
            path="/subscriptions/my-account/email-confirmation"
            component={EmailConfirmationPage}
                    />
          <Route
            path="/subscriptions/confirm"
            component={withRedirect(PaymentConfirmation)}
                    />
          <Route
            path="/subscriptions/subscription/:subscriptionReference/:offerReference/:voucherCode"
            component={CustomCampaignUrl}
                    />
        </StrictMode>
      </section>
    </Router>
  </Provider>
);

export default compose(
  setDisplayName('Root'),
  lifecycle({
    componentDidMount() {
      const { pathname } = history.location;

      handleHeaderAndFooterViews(pathname.includes('payment') || pathname.includes('subscriptions/confirm'));
    },
  }),
  setPropTypes({
    store: PropTypes.shape({
      subscribe: PropTypes.func,
      dispatch: PropTypes.func,
      replaceReducer: PropTypes.func,
    }).isRequired,
  }),
)(Root);
